import { ReactNode } from 'react';
import styles from './CategoryEmptyState.module.scss';
import { ChallengeCategory } from '../../../../redux/challenges';

interface CategoryEmptyStateProps {
    category: number;
    isFirst: boolean;
}

const getEmptyStateMessage = (category: number): ReactNode => {
    switch(category) {
        case 1: return <p className={styles.emptyMessage}>На сегодня обучающие испытания закончились.<br />Приходите завтра!</p>
        case 2:
        case 3:
        default: return null;
    }
};

export const CategoryEmptyState = ({ category, isFirst }: CategoryEmptyStateProps) => {
    if (category !== ChallengeCategory.Tutorial)
        return null;
    
    return (
        <div className={`${styles.emptyState} ${isFirst ? '' : styles.withMargin}`}>
            { getEmptyStateMessage(category) }
        </div>
    );
};